export default __webpack_public_path__ + "a916c0cf9db5f8c99c5020a57173d370.svg";